import React from "react";
import { Navigate } from "react-router-dom";
// The contextual rail exposes every scheduling destination beside the real work.
export default function Scheduling(){return <Navigate to="/scheduling/eg" replace/>;}
